<template>
  <div>
    <div class="query_head">
      <span class="query_pond">{{$route.params.pond_name}}</span>
      <i class="el-icon-arrow-right"></i>
      <span class="query_sensor">{{$route.params.name}}</span>
    </div>
    <div class="query_chart">
      <el-tabs v-model="activeName">
        <el-tab-pane
          v-for="(cell_param,index) in cell_params"
          :key = "index"
          :label="cell_param.typeCHN"
          :name="cell_param.snpid">
          <div class="query_history_time query_z-index">
            时间选择：
            <el-date-picker
              v-model="his_time"
              type="datetimerange"
              :picker-options="pickerOptions"
              align="right"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['12:00:00', '08:00:00']">
            </el-date-picker>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="hisQurey" ref="hisQurey" :style="{width: curWidth, height:'500px'}"></div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeName: '',
      cell_id: this.$route.params.pond_id,
      all_data: [],
      cell_params: [],
      cell_params_all: [],
      params_type: '',
      his_data_name: [],
      his_data_x: [],
      his_time: [],
      token: window.sessionStorage.getItem('token'),
      username: window.sessionStorage.getItem('username'),
      pickerOptions: {
        shortcuts: [{
          text: '最近一天',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近半年',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      flag: '0',
      curWidth: ''
    }
  },
  methods: {
    // 环境采集参数
    cellParams () {
      this.axios.get(this.$store.state.ip + 'sensordef/cellParams',
        {
          params: {'cell_id': this.cell_id},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.cell_params_all = res.data.data
        let j
        for (let i = 0; i < res.data.data.length; i++) {
          for (j = i + 1; j < res.data.data.length; j++) {
            if (res.data.data[i].type === res.data.data[j].type) {
              break
            }
          }
          if (j === res.data.data.length) {
            res.data.data[i].snpid = res.data.data[i].snpid.toString()
            this.cell_params.push(res.data.data[i])
          }
        }
        if (this.cell_params.length !== 0) {
          this.activeName = this.cell_params[0].snpid
          this.flag = '1'
        }
      }).catch(err => {
        console.log(err)
      })
    },
    drawLine () {
      this.his_data_name = []
      this.his_data_x = []
      this.axios.get(this.$store.state.ip + 'opt/hisAggrQuery',
        {
          params: {'cell_ids': this.cell_id, 'snp_types': this.params_type, 'start_time': this.his_time[0], 'end_time': this.his_time[1]},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        for (let i = 0; i < res.data.data.length; i++) {
          this.all_data = res.data.data[i].sntvs
        }
        var series = []
        let j = -1
        const color1 = ['#91c7ae', '#d48265', '#61a0a8', '#2f4554', '#749f83', '#c23531']
        this.his_data_x = this.all_data[0].times
        for (let i = 0; i < this.all_data.length - 1; i++) {
          for (let j = i + 1; j < this.all_data.length; j++) {
            if (this.all_data[i].times.length < this.all_data[j].times.length) {
              this.his_data_x = this.all_data[j].times
            }
          }
        }
        for (let t = 0; t < this.his_data_x.length; t++) {
          this.his_data_x[t] = this.resetTime(this.his_data_x[t])
        }
        for (let i = 0; i < this.all_data.length; i++) {
          j = j + 1
          if (j === 6) {
            j = 0
          }
          for (let k = 0; k < this.cell_params_all.length; k++) {
            if (this.all_data[i].snpid.toString() === this.cell_params_all[k].snpid.toString()) {
              this.his_data_name[i] = this.cell_params_all[k].name
            }
          }
          var test = []
          for (let k = 0; k < this.all_data[i].times.length; k++) {
            test = test.concat({'time': this.resetTime(this.all_data[i].times[k]), 'value': this.all_data[i].values[k]})
          }
          series.push({
            name: this.his_data_name[i],
            type: 'line',
            itemStyle: {
              normal: { // 背景色渐变
                lineStyle: { // 折线样式
                  width: 2.5,
                  type: 'solid',
                  color: color1[j] // 拆线颜色
                }
              },
              emphasis: {
                color: color1[j],
                lineStyle: {
                  type: 'dotted',
                  color: color1[j]
                }
              }
            },
            symbolSize: 5,
            data: test
          })
        }
        let mycharts = this.$echarts.init(this.$refs.hisQurey)
        mycharts.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          color: ['#91c7ae', '#d48265', '#61a0a8', '#2f4554', '#749f83', '#c23531'],
          legend: {
            left: 20,
            data: this.his_data_name
          },
          dataZoom: [
            {
              show: true,
              realtime: true,
              start: 0
              // end: 25 / this.his_data_x[0].length * 100
            },
            {
              type: 'inside',
              realtime: true,
              start: 0,
              end: 100
            }
          ],
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: this.his_data_x
            }
          ],
          yAxis: [
            {
              type: 'value',
              axisTick: {
                show: false
              }
            }
          ],
          series: series
        }, true)
      }).catch(err => {
        console.log(err)
      })
    },
    // 时间戳转换为标准时间
    resetTime (time) {
      let test = new Date(time * 1000)
      let year = test.getFullYear() // 取得4位数的年份
      let month = ('0' + (test.getMonth() + 1)).slice(-2) // 取得日期中的月份，其中0表示1月，11表示12月
      let date = ('0' + test.getDate()).slice(-2) // 返回日期月份中的天数（1到31）
      let hour = ('0' + test.getHours()).slice(-2) // 返回日期中的小时数（0到23）
      let minute = ('0' + test.getMinutes()).slice(-2) // 返回日期中的分钟数（0到59）
      let second = ('0' + test.getSeconds()).slice(-2) // 返回日期中的秒数（0到59）
      return year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
    },
    changeTime (time) {
      const resDate = time.getFullYear() + '-' + this.p((time.getMonth() + 1)) + '-' + this.p(time.getDate())
      const resTime = this.p(time.getHours()) + ':' + this.p(time.getMinutes()) + ':' + this.p(time.getSeconds())
      return resDate + ' ' + resTime
    },
    p (s) {
      return s < 10 ? '0' + s : s
    }
  },
  created () {
    this.cellParams()
    this.curWidth = document.body.clientWidth - 260 + 'px'
    const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24)
    this.his_time = [this.changeTime(start), this.changeTime(end)]
  },
  watch: {
    $route (to, from) {
      this.$router.go(0)
    },
    'activeName': function () {
      for (let i = 0; i < this.cell_params.length; i++) {
        if (this.activeName === this.cell_params[i].snpid) {
          this.params_type = this.cell_params[i].type
          break
        }
      }
      this.drawLine()
    },
    'his_time': function () {
      if (this.flag === '1') {
        this.drawLine()
      }
    }
  }
}
</script>

<style scoped>
  .hisQurey{
    margin: 0 auto;
    margin-top: -30px;
    padding-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/userData/AllNum.vue